import type { IconAliases, IconProps } from 'vuetify'

/* eslint-disable regex/invalid */
import checkboxChecked from '@images/svg/checkbox-checked.svg'
import checkboxIndeterminate from '@images/svg/checkbox-indeterminate.svg'
import checkboxUnchecked from '@images/svg/checkbox-unchecked.svg'
import radioChecked from '@images/svg/radio-checked.svg'
import radioUnchecked from '@images/svg/radio-unchecked.svg'

const customIcons: Record<string, unknown> = {
  'mdi-checkbox-blank-outline': checkboxUnchecked,
  'mdi-checkbox-marked': checkboxChecked,
  'mdi-minus-box': checkboxIndeterminate,
  'mdi-radiobox-marked': radioChecked,
  'mdi-radiobox-blank': radioUnchecked,
}

const aliases: Partial<IconAliases> = {
  info: 'ri-error-warning-line',
  success: 'ri-checkbox-circle-line',
  warning: 'ri-alert-line',
  error: 'ri-error-warning-line',
  calendar: 'ri-calendar-2-line',
  collapse: 'ri-arrow-up-s-line',
  complete: 'ri-check-line',
  cancel: 'ri-close-line',
  close: 'ri-close-line',
  delete: 'ri-close-circle-fill',
  clear: 'ri-close-line',
  prev: 'ri-arrow-left-s-line',
  next: 'ri-arrow-right-s-line',
  delimiter: 'ri-checkbox-blank-circle-line',
  sort: 'ri-arrow-up-line',
  expand: 'ri-arrow-down-s-line',
  menu: 'ri-menu-line',
  subgroup: 'ri-arrow-down-s-fill',
  dropdown: 'ri-arrow-down-s-line',
  edit: 'ri-pencil-line',
  ratingEmpty: 'ri-star-line',
  ratingFull: 'ri-star-fill',
  ratingHalf: 'ri-star-half-line',
  loading: 'ri-refresh-line',
  first: 'ri-skip-back-mini-line',
  last: 'ri-skip-forward-mini-line',
  unfold: 'ri-split-cells-vertical',
  file: 'ri-attachment-2',
  plus: 'ri-add-line',
  minus: 'ri-subtract-line',
  sortAsc: 'ri-arrow-up-line',
  sortDesc: 'ri-arrow-down-line',
  search: 'ri-search-2-line',
  location: 'ri-map-pin-2-fill',
  money: 'ri-money-euro-circle-line',
  heart: 'ri-heart-2-line',
  inbox: 'ri-message-2-fill',
  phone: 'ri-phone-find-line',
  profile: 'ri-profile-fill',
  facebook: 'ri-facebook-circle-fill',
  twitter: 'ri-twitter-x-fill',
  github: 'bxl-github',
  linkedin: 'bxl-linkedin',
  quantity: 'ri-scales-2-line',
  condition: 'ri-moon-clear-line',
  type: 'ri-store-2-line',
  title: 'ri-pencil-fill',
  negotiable: 'ri-speak-fill',
  category: 'ri-drinks-line',
  share: 'ri-share-line',
  bookmark: 'ri-bookmark-line',
  bookmark_outline: 'ri-bookmark-fill',
  verification: 'ri-verified-badge-line',
  view: 'ri-external-link-line',
  headset: 'ri-headphone-fill',
  flash: 'ri-flashlight-fill',
  arrowright: 'ri-arrow-right-s-line',
  arrowleft: 'ri-arrow-left-s-line',
  cityVariant: 'ri-city-variant-outline',
  multipleTag: 'ri-checkbox-multiple-blank-line',
  scale: 'ri-scales-line',
  imagePlus: 'ri-image-add-line',
  naira: 'ri-currency-line',
  handshake: 'ri-shake-hands-line',
  star: 'ri-star-line',
  bankCard: 'ri-bank-card-2-line',
  rocket: 'ri-rocket-fill',
  Ads: 'ri-advertisement-fill',
  trendingLine: 'ri-funds-line',
  shuffleLine: 'ri-shuffle-line',
  instagram: 'ri-instagram-fill',
}
/* eslint-enable */

export const iconify = {
  component: (props: IconProps) => {
    // Load custom SVG directly instead of going through icon component
    if (typeof props.icon === 'string') {
      const iconComponent = customIcons[props.icon]

      if (iconComponent)
        return h(iconComponent)
    }

    return h(
      props.tag,
      {
        ...props,

        // As we are using class based icons
        class: [props.icon],

        // Remove used props from DOM rendering
        tag: undefined,
        icon: undefined,
      },
    )
  },
}

export const icons = {
  defaultSet: 'iconify',
  aliases,
  sets: {
    iconify,
  },
}
